export default {

  // Возвращает список дочерних аккаунтов
  getUsers () {
    return env.API.post('/user/getSubs');
  },

  // Возвращает тикеты определенного юзера ({page: 0, take: 100, userId: user['id']})
  getTickets (data) {
    return env.API.post('/user/ticket/getAllFromUser', data);
  },

  // Изменяет данные юзера Обязательные поля subUserId и те что нужно для изменения своего акка
  changeGeneral (data) {
    return env.API.post('/user/changeGeneralForSub', data);
  },

  // Изменяет пароль юзера ({newPassword: 'qweqwe', subUserId: user['id']})
  changePassword (data) {
    return env.API.post('/user/changePasswordForSub', data)
  },

  // Удаляет юзера
  deleteUser (id) {
    return env.API.post('/user/deleteUser', {subUserId: id})
  },

  // Отвязывает юзера 
  unConnectUser (id) {
    return env.API.post('/user/unConnectUser', {subUserId: id})
  },

  // Заблокировать юзера  
  blockUser (id) {
    return env.API.post('/user/blockUser', {subUserId: id})
  },

  // Разблокировать юзера 
  unBlockUser (id) {
    return env.API.post('/user/unBlockUser', {subUserId: id})
  },

  // Возвращает список пдф программ юзера ({page: 0, take: 100, subUserId: user['id']})
  getPdf (data) {
    return env.API.post('/pdf/getPdfByUser', data);
  },

  // Возвращает филды юзера
  getFields (id) {
    return env.API.get('/user/field/allByUser?subUserId='+id);
  },

  // Возвращает проги юзера ({page: 0, take: 100, subUserId: user['id']})
  getPrograms (data) {
    return env.API.post('/user/program/getAllByUser', data);
  },

  // Удаляет прогу юзера, нужен только айди программы
  deleteProgram (id) {
    return env.API.post('/user/program/deleteByUser', {programId: id});
  },

  // Возвращает кропы доступные юзера
  getCrops (id) {
    return env.API.post('/user/crop/getPersonalByUser', {subUserId: id});
  },

  // Возвращает фертилайзеры юзера
  getFertilizers (id) {
    return env.API.post('/user/fertilizer/getAllByUser', {subUserId: id});
  },

  // Меняет фертилайзер юзера, данные те же что и для изменения своего фертилайзера
  edigFertilizers (data) {
    return env.API.post('/user/fertilizer/editFertByUser', data);
  },
  
}